<template>
<div class="col-sm-2 col-xs-2 inside_pages_left">
    <!-- <div class="inside_pages_left_top">
    </div> -->
    <div class="inside_pages_left_menu">
        <el-menu :default-active="thisLeftMenu" class="inside_pages_left_menu_box" active-text-color="#1C71FB" :unique-opened="true">
            <template v-for="(valueOne,keyOne) in menuList">
                <el-submenu v-if="valueOne.list.length>=1" :index="keyOne+''" :key="keyOne">
                    <template slot="title">
                        <i :class="valueOne.icon"></i>
                        <span>{{valueOne.name}}</span>
                    </template>
                    
                    <el-menu-item  v-for="(valueTwo,keyTwo) in valueOne.list"  :index="keyOne+'-'+keyTwo" :key="keyTwo" @click="jump(valueTwo.path,2,valueOne.jumpMode,keyOne,keyTwo)">
                        <span>{{valueTwo.name}}</span>
                        <i class="el-icon-right"></i>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item  v-if="valueOne.list.length==0" :index="keyOne+''" :key="keyOne"  @click="jump(valueOne.path,2,valueOne.jumpMode,keyOne,'')">
                    <i :class="valueOne.icon"></i>
                    <span>{{valueOne.name}}</span>
                </el-menu-item>
                
            </template>
        </el-menu>
    </div>
</div>
</template>

<script>
export default {
    name:'LeftMenu',
    components: {},
    props: {
        dataList:''
    },
    data() {
        return {
            // menuList:this.dataList
            menuList:JSON.parse(sessionStorage.getItem('pageSubmenu')) || [],
            // menuList:[],
            thisLeftMenu:''
        };
    },
    created() {},
    mounted() {
        if(this.$store.state.isSafeInfo){
            this.getInfo();
        }else{
            this.getPosture();
        }
        this.filterMenu();
        
        this.selectLeftMenu(this.menuList)
    },
    computed: {
        isSafeInfo () {
            return this.$store.state.isSafeInfo;
        },
        userInfo(){
            return this.$store.getters.getUserInfo;
        }
    },
    watch: {
        menuList:function(nval){
            // console.log(nval)
            this.selectLeftMenu(nval)
        }
    },
    methods: {
        // 刷新后重新选择选中位置
        selectLeftMenu(nval) {
            let menuListKeyOne = this.$store.state.menuListKeyOne;
            let menuListKeyTwo = this.$store.state.menuListKeyTwo;
            // console.log(11111111111)
            // console.log(menuListKeyOne,menuListKeyTwo)
            // console.log(111111111111)
            if (nval[menuListKeyOne].list.length == 0) {
                // this.thisLeftMenu = '0'
                this.thisLeftMenu = menuListKeyOne.toString();
            }else{
                // this.thisLeftMenu = '0-0'
                if(menuListKeyTwo === '') {
                    menuListKeyTwo = 0;
                }
                this.thisLeftMenu = menuListKeyOne + "-" + menuListKeyTwo;
            }
        },
        jump(path,num,mode,keyOne = "",keyTwo = ""){
            // console.log(path)
            // console.log(11111111111)
            // console.log(keyOne,keyTwo)
            // console.log(111111111111)
            if(path == '/drill_center' || path == '/safeposture_school'||path == '/CloudDrillCenter' ) {
                let routeUrl = this.$router.resolve({
                    path: path,
                });
                window.open(routeUrl.href, "_blank");
            } else {

                this.$store.commit('updateMenuListKeyOne',keyOne)
                this.$store.commit('updateMenuListKeyTwo',keyTwo)
                this.$Common.pageJump(path,num,mode);
            }
        
        },
        filterMenu(){
            for(var oneKye in this.menuList){
                // console.log(this.menuList[oneKye].path)
                if(this.$route.path == this.menuList[oneKye].path){
                    // this.thisLeftMenu = this.$route.path
                    // console.log(this.thisLeftMenu+'------------------')
                    sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                }
                
                if(this.menuList[oneKye].list.length>=1){
                    for(var twoKey in this.menuList[oneKye].list){
                        // console.log(this.menuList[oneKye].list[twoKey].path)
                        if(this.$route.path == this.menuList[oneKye].list[twoKey].path){
                            
                            // this.thisLeftMenu = this.$route.path
                            // console.log(this.thisLeftMenu+'------------------')
                            sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                        }
                        // console.log(this.menuList[oneKye].list[twoKey].path)
                        if(this.menuList[oneKye].list[twoKey].showStatus == 0){
                            
                            this.menuList[oneKye].list.splice(twoKey,1) 
                        }
                        
                    }
                }
            }
            // this.thisLeftMenu = sessionStorage.getItem('selectedLeftMenu')
            // console.log(this.thisLeftMenu)
        },

        // 安全资料类
        getInfo(){
            let list = []
            // console.log(this.userInfo,'-------------')
            if (this.userInfo.eduBuresuType == -1) {
                list = this.$store.state.menu.menuListAccount
            }else{
                list = this.$store.state.menu.menuListTwo
            }
            list.forEach(menuOne => {
                menuOne.subMenuList.forEach(menuTwo=>{
                    if(this.$route.path == menuTwo.path){
                        sessionStorage.setItem('pageSubmenu',JSON.stringify(menuOne.subMenuList))
                        sessionStorage.setItem('thisOnePagePath', menuOne.path)
                        sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                        this.menuList = menuOne.subMenuList
                        // this.thisLeftMenu = this.$route.path
                    }
                    menuTwo.list.forEach(menuThree=>{
                        if(this.$route.path == menuThree.path){
                            // console.log(menuOne.subMenuList)
                            // for(var i in menuOne.subMenuList.list){
                            //     console.log(123)
                            // }
                            // this.thisLeftMenu = this.$route.path
                            // console.log(menuOne.path)
                            // console.log(this.$route.path)
                            // this.menuList = menuOne.subMenuList
                            sessionStorage.setItem('pageSubmenu',JSON.stringify(menuOne.subMenuList))
                            sessionStorage.setItem('thisOnePagePath', menuOne.path)
                            sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                            this.menuList = menuOne.subMenuList
                            // this.thisLeftMenu = this.$route.path

                        }
                    })
                    
                })
                
            });
        },
        // 安全态势类
        getPosture(){
            this.$store.state.menu.indexMenu.forEach(menuOne => {
                menuOne.subMenuList.forEach(menuTwo=>{
                    if(this.$route.path == menuTwo.path){
                        sessionStorage.setItem('pageSubmenu',JSON.stringify(menuOne.subMenuList))
                        sessionStorage.setItem('thisOnePagePath', menuOne.path)
                        sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                        this.menuList = menuOne.subMenuList
                        // this.thisLeftMenu = this.$route.path
                    }
                    menuTwo.list.forEach(menuThree=>{
                        if(this.$route.path == menuThree.path){
                            // console.log(menuOne.subMenuList)
                            // for(var i in menuOne.subMenuList.list){
                            //     console.log(123)
                            // }
                            // this.thisLeftMenu = this.$route.path
                            // console.log(menuOne.path)
                            // console.log(this.$route.path)
                            // this.menuList = menuOne.subMenuList
                            sessionStorage.setItem('pageSubmenu',JSON.stringify(menuOne.subMenuList))
                            sessionStorage.setItem('thisOnePagePath', menuOne.path)
                            sessionStorage.setItem('selectedLeftMenu',this.$route.path)
                            this.menuList = menuOne.subMenuList
                            // this.thisLeftMenu = this.$route.path

                        }
                    })
                    
                })
                
            });
        }
    }
};
</script>
<style scoped>
</style>